;(function (window, Backbone, Marionette, $, _, AjaxErrorHandlerManager, PermissionManager) {
	'use strict';

	var APP = new Marionette.Application();

	window.APP = APP;
	window.EXPORTS = {};
	window.EXPORTS.GLOBAL_DATA = {};
	//window.APP.IS_PRELAUNCH = window.IS_PRELAUNCH || true;

	if (typeof Connextra === 'function') {
		APP.Connextra = new Connextra();
	}

	if (typeof FGPFacebook === 'function') {
		APP.FGPFacebook = new FGPFacebook();
	}

	var page_view_analitics = false;
	 window.ajax_is_aborted = true;
	//Backbone.fetchCache.localStorage = false;

	Backbone.ajax = function(request) {
		request = _({ contentType: 'application/x-www-form-urlencoded' }).defaults(request);
		return Backbone.$.ajax.call(Backbone.$, request);
	};

	var originalFn = Backbone.history.loadUrl;
	Backbone.history.loadUrl = function() {
		Backbone.history.previousFragment = Backbone.history.fragment || '';
	    return originalFn.apply(this, arguments);
	};

	var proxiedSync = Backbone.sync;
	Backbone.sync = function(method, model, options) {
		options || (options = {});

		var model_url = typeof model.url === 'function' ? model.url() : model.url,
			is_json   = _.isString(model_url) && model_url.indexOf('.json') !== -1,
			api_url   = is_json ? CONFIG.JSON_SPORT_URL : CONFIG.API_URL;


		if (options.is_project_json && is_json) {
			api_url = CONFIG.JSON_URL;
		}

		if (!options.crossDomain) {
			options.crossDomain = true;
		}

		options.url = api_url + model_url;

		_.extend(options, {
			emulateHTTP: true,
			emulateJSON: false,
			beforeSend: function(xhr, settings) {
				if (!settings.data) {
					settings.data = {};
				}
				// settings.data is a body of our request.
				if (_.isString(settings.data)) {
					settings.data = Backbone.$.parseJSON(settings.data);
				}

				if (!is_json) {
					settings.data.sid = APP.getJStorage('session_id') || '';
				}
				settings.data._ = +(new Date());

				settings.data = Backbone.$.param(settings.data);

				if (settings.type === 'GET') {
					var sign      = settings.url.split('?')[1] ? '&' : '?';
					settings.url += sign + settings.data;
				}
			}
		});

		return proxiedSync.apply(this, arguments);
	};

	Backbone.Collection.prototype.save = function (options) {
		return Backbone.sync("create", this, options);
	};

	var extend = {};

	extend.modelAndCollection = {
		parse: function(resp) {
			return resp.result || resp;
		},
		url: function() {
			return this.methodUrl;
		},
		getPrefix: function() {
			let prefix = i18next.hasOwnProperty('language') && i18next.language.substring(0, 2);

			if (!prefix) {
				prefix = CONFIG.LANGS[0];
			}

            if(typeof numeral === 'function'){
                numeral.locale(prefix);   // set Locale for numbers
			}

			return prefix + '/';
		},
		setApiUrl: function(url, is_json){

			if(!url || !_.isString(url)){
				return this;
			}

			if(this.api_prefix){
				url = this.api_prefix + url;
			}

			if (CONFIG.IS_MULTY_LANG && !is_json) {
				url = this.getPrefix() + url;
			}

			this.methodUrl = url;

			return this;
		},

		toObject: function () {
			return _.indexBy(this.toJSON(), 'id');
		}
	};

	extend.views = {
		showErrors: function(errors, title) {
			var errors_text = '';
			_.each(errors, function(error) {
				errors_text += error.text + "\n";
			});

			APP.vent.trigger('popup:message:show', errors_text, title);
			this.hidePreloader();
			return this;
		},

		alertErrors(errors) {
			let errors_text = '';
			_.each(errors, function(error) {
				errors_text += error.text + "\n";
			});

			alert(errors_text);

			this.hidePreloader();
			return this;
		},

		showPreloader: function() {
			return this.setPreloaderState('show');
		},

		hidePreloader: function() {
			return this.setPreloaderState('hide');
		},

		setPreloaderState: function(state) {
			this.debouncedSetPreloaderState(state);
			return this;
		},

		debouncedSetPreloaderState: _.debounce(function(state) {
			$(document).find('#loading')[state]();
		}, 50),

		scrollToTop: function(cord) {
			$('html, body').animate({
				scrollTop: cord || 0
			});

			return this;
		},
		setOnLocationChangeListener: function(text) {
			text = text || '';
			$(window).on('beforeunload', function(){
				if(APP.is_not_saved) {
					return text;
				}
			});

			return this;
		}
	};

	APP.vent.on('preloader:show', _.bind(extend.views.debouncedSetPreloaderState, null, 'show'));
	APP.vent.on('preloader:hide', _.bind(extend.views.debouncedSetPreloaderState, null, 'hide'));

	window.mcn_methods = {
		get_publisher: function () {
			return CONFIG.FRONT_HOST.indexOf('aflw') !== -1 ? 'afl' : "afl.clubs";
		},
		get_clubs: function() {
			return {
				'aflw':            'wtipping',
				'adelaidecrows':   'Crows',
				'afc':             'Crows',
				'lions':           'Lions',
				'brisbanelions':   'Lions',
				'carlton':         'Blues',
				'collingwood':     'Magpies',
				'essendon':        'Bombers',
				'fremantle':       'Dockers',
				'geelongcats':     'Cats',
				'gwsgiants':       'Giants',
				'hawthorn':        'Hawks',
				'nmfc':            'Kangaroos',
				'northmelbourne':  'Kangaroos',
				'portadelaide':    'Power',
				'richmond':        'Tigers',
				'sydneyswans':     'Swans',
				'westcoasteagles': 'Eagles',
				'westernbulldogs': 'Western Bulldogs',
				'stkilda':         'saints',
				'saints':          'saints'
			}
		},
		get_pages: function () {
			return {
				'#login':                'Tipping/Home',
				'#registration':         'Tipping/Registration',
				'#tipping/rankings':     'Tipping/Ranking',
				'#tipping/league':       'Tipping/Comps',
				'#help/prizes':          'Tipping/Prizes',
				'#tipping/gauntlet':     'Tipping/Gauntlet',
				'#tipping':              'Tipping/Tipping',
				'#help/game-guidelines': 'Tipping/Other',
				'#help/faqs':            'Tipping/Other',
				'#help/game-rules':      'Tipping/Other',
				'#help/terms':           'Tipping/Other',
				'#help/contact-us':      'Tipping/Other'
			}
		},
		get_area_targeting: function ( clubs_config ) {

			var pages = clubs_config,
				keys = Object.keys(pages),
				hash = window.location.hash,
				i, area_page;

			for (i = 0; i < keys.length; i++) {
				if (hash.indexOf(keys[i]) !== -1) {
					area_page = pages[keys[i]];
					break;
				}
			}

			if (!area_page) area_page = 'Tipping/Other';

			return area_page;
		},
		get_club_targeting: function ( clubs_config ) {

			var clubs = clubs_config,
				keys = Object.keys(clubs),
				hash = CONFIG.FRONT_HOST,
				i, area_club;

			for (i = 0; i < keys.length; i++) {
				if (hash.indexOf(keys[i]) !== -1) {
					area_club = clubs[keys[i]];
					break;
				}
			}

			if (!area_club) {
				area_club = 'No Club';
			}

			return area_club;

		},
		get_device_targeting: function () {
			return $(window).width() <= 768 ? 'Mobile' : 'Desktop';
		}
	};


	var refreshGoogleTag = _.debounce(function () {
		if (window.googletag && typeof googletag !== 'undefined') {
			if (googletag.pubadsReady) {
				googletag.pubads().refresh();
			} else {
				var interval = setInterval(function () {
					if (googletag.pubadsReady) {
						googletag.pubads().refresh();
						clearInterval(interval)
					}
				}, 10)
			}
		}
	});

	extend.router = {
		initialize: function () {
			this.options.controller.permissions = {};

			_.each(this.appRoutes, function(key, val) {
				this.options.controller.permissions[key] = 0;
			}, this);

			_.extend(this.options.controller.permissions, this.permissions);
		},
		execute: function(callback, args, name) {
			this.pageView();

			//if(APP.IS_PRELAUNCH && !this.isPreLaunchTrick(name)){
			//	return this;
			//}

			var _this = this;
			var isUnsaved = this.checkForSaved();
			if (isUnsaved instanceof Promise)
			{

				isUnsaved.then(function(is_saved) {

					if (is_saved) {
						console.log(name);
						return _this.backToPreviousRoute(args, name);
					}

					if (!_this.checkForOffSeason()) {
						return;
					}
					if(PermissionManager.check(_this, name) && callback){
						_this.changeRoute(callback, args, name);
					}
					else {
						Backbone.history.navigate(Backbone.history.previousFragment, {trigger: false});
					}
				});
				return this;
			}
			else{
				if (isUnsaved){
				return this.backToPreviousRoute(args, name);
				}

				if (!this.checkForOffSeason()) {
					return this;
				}
				if(PermissionManager.check(this, name) && callback){
					this.changeRoute(callback, args, name);
				}
				else {
					Backbone.history.navigate(Backbone.history.previousFragment, {trigger: false});
				}
			}

		},

		isPreLaunchTrick: function(path_name){
			var
				is_root = (path_name === 'index'),
				is_can_access_pages = !!APP.getJStorage('PreLaunchTrick'),
				is_has_access = is_root || is_can_access_pages
				;

			if(!is_has_access){
				Backbone.history.navigate('/', {trigger: true});
			}

			return is_has_access;
		},

		changeRoute: function(callback, args, name){
			if (window.ajax_is_aborted) {
				$.ajaxQ.abortAll();
				window.ajax_is_aborted = true;
			}

			APP.vent.trigger('preloader:hide');
			//APP.module('instance').menu.refresh();
			Backbone.history.location.pathmethod = name;
			APP.vent.trigger('route:change', name);
			callback.apply(this, args);

			return this;
		},

		pageView: function(){
			var url = Backbone.history.getFragment();
			if (!/^\//.test(url)) {
				url = '/' + url;
			}
			if(CONFIG.GOOGLE_ACCOUNT_ID && typeof window.ga === "function"){
				ga('send', {
					'hitType': 'pageview',
					'page': url
				});
			}

			//if (CONFIG.IS_MULTY_LANG) {
			if (typeof sendAnalitycs === "function" && page_view_analitics) {
				sendAnalitycs('view_page', url);
			}
			//}

			if (typeof _satellite !== 'undefined') {
				_satellite.track(CONFIG.ABSPATH+'#'+url);
			}

			if(!_.isUndefined(window.googletag) && refreshGoogleTag && CONFIG.SPORT !== 'bbl') {
				refreshGoogleTag();
			}

			if ( typeof _mcn !== "undefined" && typeof _mcn.amf !== "undefined" ) {
				_mcn.config=[];
				_mcn.config.push(function () {
					_mcn.publisher( window.mcn_methods.get_publisher() );

					if ( window.mcn_methods.get_club_targeting( window.mcn_methods.get_clubs() ) !=  'wtipping' ) {
						//exclude wtipping from clubs tracking
						_mcn.amf.targeting("area",   window.mcn_methods.get_area_targeting( window.mcn_methods.get_pages() ) );
						_mcn.amf.targeting("Club",   window.mcn_methods.get_club_targeting( window.mcn_methods.get_clubs() ) );
						_mcn.amf.targeting("device", window.mcn_methods.get_device_targeting() );
						//------------------------------------
					}
					else {
						_mcn.amf.targeting("area",  'wtipping' );
						_mcn.amf.targeting("device", window.mcn_methods.get_device_targeting() );
						_mcn.amf.postLoadAdCall(true);
					}

				});

				setTimeout(function () {

					var sidebar_promo = $('#login-sidebar-promo');
					if ( sidebar_promo.length ) {

						if ( !sidebar_promo.is(':visible') ) {
							_mcn.amf.insertAd('login-sidebar-promo');
						}

					}

				}, 3000);

			}
		},
		off_season_route: '#off-season',
		checkForOffSeason: function () {
			if ( CONFIG.OFF_SEASON && window.location.hash.indexOf(this.off_season_route) === -1) {
				Backbone.history.navigate(this.off_season_route, {trigger: true});
				return false;
			}
			return true;
		},

		confirm: function(text) {
			var $confirm = $('<div />');
			$confirm.addClass('popup-container');

			$confirm.html('' +
				'<div class="popup-overlay"></div>'+
				'<div class="popup-block fixed custom-confirm-modal">'+
				'<div class="popup-content">'+
				'<h4>'+text+'</h4>' +
				'<div style="text-align: right">' +
					'<button style="width:6em;height:2em;margin-right: 0.5em" value="yes">Yes</button>' +
					'<button style="width:6em;height:2em;margin-left: 0.5em" value="no">No</button>' +
				'</div>'+
				'</div>'+
				'</div>'
			);

			return new Promise(function(resolve) {
				$confirm.on('click', 'button',function(){
					resolve($(this).val() === 'yes');
					$confirm.remove();
				});

				$('body').append($confirm);
			});
		},

		checkForSaved: function() {
			var _this = this;
			return new Promise(function(resolve) {
				if (!APP.is_not_saved) {
					return resolve(false);
				}

				var text = APP.confirm_messsage || 'Are you sure you want to navigate away from this page, you have not confirmed the changes you have made to your team. Any changes that aren\'t confirmed will not be saved.';

				_this.confirm(text).then(function(is_not_saved) {
					APP.is_not_saved = !is_not_saved;
					resolve(APP.is_not_saved)
				});
			});
		},

		backToPreviousRoute: function() {
			var history = Backbone.history;
			history.navigate(history.previousFragment, {trigger: true});

			return false;
		}
	};

	_.extend(Backbone.Model.prototype, extend.modelAndCollection);
	_.extend(Backbone.Collection.prototype, extend.modelAndCollection);
	_.extend(Backbone.View.prototype, extend.views);
	_.extend(Backbone.Router.prototype, extend.router);
	_.extend(Marionette.View.prototype, {
		image_url:         CONFIG.IMAGES_URL,
		AVATARS_IMAGE_URL: CONFIG.AVATARS_URL,
		PLAYERS_IMAGE_URL: CONFIG.PLAYERS_URL,
		SQUADS_IMAGE_URL:  CONFIG.SQUADS_URL
	});
	//APP.confirm_messsage = false;
	APP.module = (function(){
		var MODULES = {};

		return function (ns_string) {
	        if(typeof ns_string !== 'string' || !ns_string){
	            return MODULES;
	        }

	        var
	            parts       = ns_string.split('.'),
	            parent      = MODULES,

	            len = parts.length,
	            i
	        ;

	        for (i = 0; i < len; i++) {
	            if (typeof parent[parts[i]] === 'undefined') {
	                parent[parts[i]] = {};
	            }

	            parent = parent[parts[i]];
	        }

	        return parent;
	    };

	}());

	APP.module().PubSub = {
		events: {},
		on: function(type, callback){
			var evt = this.events[type] = (this.events[type] || []);
			evt.push(callback.bind(this));

			return this;
		},
		trigger: function(type){
			var evt = this.events[type];
			if(!evt) return this;
			_.each(evt, function(f){ f(); });

			return this;
		}
	};

	APP.addRegions({
		popup_message: '#popup-message',
		mobMenu:       '#mobile-menu',
		header:        '#header',
		main:          '#main',
		footer:        '#footer',
		fh_footer:     '#fh_footer',
		notification_bar: '#notification-bar'
	});

	APP.clearUser = function() {
		// Clear all data.
		$.jStorage.flush();
		try {
			if (CONFIG.OFF_SEASON && window.localStorage.getItem('lang_to_use')) { //if is preseason registration
				let temp_lang = window.localStorage.getItem('lang_to_use');
				window.localStorage.clear();
				window.localStorage.setItem('lang_to_use', temp_lang);
			}
			else {
				window.localStorage.clear();
			}
		}
		catch (e) {

		}

	};

	APP.clearUserAndRedirectToLogin = function() {
		APP.clearUser();

		// Remember page that we can back to this page after login.
		APP.setJStorage('backTo', window.location.hash);

		// Redirect to login page.
		Backbone.history.navigate('/', {trigger: true});

		return false;
	};

	APP.clearUserAndRedirectToLoginSSO = function() {
		const id_token = localStorage.getItem("id_token");
		if (id_token) {
			const link = CONFIG.ENVIRONMENT === 'production' ? 'login.id.afl' : 'id.test.afl';
			const params = [
				`id_token_hint=${id_token}`,
				`post_logout_redirect_uri=${CONFIG.ABSPATH}`,
				`client_id=${CONFIG.AFL_ID_CLIENT_ID}`,
			];
			const logoutURL = `https://${link}/oauth2/v1/logout?${params.join("&")}`;
			APP.clearUser();

			// Remember page that we can back to this page after login.
			APP.setJStorage('backTo', window.location.hash);

			window.location.assign(logoutURL);
		} else {
			APP.clearUser();

			// Remember page that we can back to this page after login.
			APP.setJStorage('backTo', window.location.hash);
			// Redirect to login page.
			// Backbone.history.navigate('/', {trigger: true});
			Backbone.history.navigate('/', {trigger: true});
		}

		return false;
	};

	APP.registerForGameRedirect = function(){

		Backbone.history.navigate('registration/for_game', {trigger: true});

		return false;
	};

	const jStorage_prefix = CONFIG.ENVIRONMENT + '_';

	// jStorage wrappers
	APP.setJStorage = function(key, value, TTL) {
		let options = null;

		if(TTL){
			options = {TTL: TTL};
		}

		$.jStorage.set(jStorage_prefix + key, value, options);
	};

	APP.getJStorage = function(key, defaultValue) {
		return $.jStorage.get(jStorage_prefix + key, defaultValue);
	};

	APP.getAndDeleteJStorage = function(key, defaultValue) {
		var result = this.getJStorage(key, defaultValue);
		this.delJStorage(key);
		return result;
	};

	APP.delJStorage = function(key) {
		var storage_key = jStorage_prefix + key;
		$.jStorage.deleteKey(storage_key);
	};

	APP.flushJStorage = function() {
		$.jStorage.flush();
		'localStorage' in window && localStorage.clear();
	};

	APP.clearSecret = function() {
		APP.setJStorage('PreLaunchTrick', true);
		CONFIG.OFF_SEASON = false;
		CONFIG.IS_PRELAUNCH = false;
		Backbone.history.navigate('/', { trigger: true });
		//window.location.reload();
	}

	APP.parseCookies = function(cookieString = document.cookie) {
		return cookieString
			.split('; ')
			.reduce((cookies, cookie) => {
				const [name, ...valueParts] = cookie.split('=');
				cookies[decodeURIComponent(name)] = decodeURIComponent(valueParts.join('='));
				return cookies;
			}, {});
	}

	AjaxErrorHandlerManager.onErrorCode({
		401: APP.clearUserAndRedirectToLogin, // User not authorized
		517: APP.clearUserAndRedirectToLogin,
		513: APP.registerForGameRedirect
	});

	$(document).ajaxComplete(function(event, xhr, settings){
		AjaxErrorHandlerManager.responseCheck(event, xhr, settings);
		APP.AppCacheManager && APP.AppCacheManager.checkAndUpdate(xhr);
	});

	function reloadPageOnRoute(){
		Backbone.history.on('route', function() {
			window.location.reload();
		});
	}

	if (CONFIG.IS_MULTY_LANG) {
		document.addEventListener("i18Loaded", function(options) {
			appStart();
		});
		document.addEventListener("analitycs_event", function(options) {
			if (typeof sendAnalitycs === "function") {
				page_view_analitics = true;
				sendAnalitycs('start');
			}
		});

	}
	else {
		appStart();
	}

	function appStart() {
		$(function() {
			APP.module().PubSub.on('updateready', _.once(reloadPageOnRoute));

			if (typeof sendAnalitycs === "function" && !page_view_analitics) {
				page_view_analitics = true;
			}

			if(CONFIG.IS_PRELAUNCH){
				if (APP.getJStorage('PreLaunchTrick')) {
					CONFIG.OFF_SEASON = false;
				}
				else {
					CONFIG.OFF_SEASON = true;
					APP.clearUserAndRedirectToLogin();
				}
			}
			APP.setJStorage('geo_ip_checked', false);
			APP.start();

			Backbone.history.start({
				pushState: false,
				root: '/'
			});

			if (CONFIG.IS_MULTY_LANG) {
				checkLanguage();
			}

		});
	}



	function checkLanguage() {
		var user = APP.module('instance').user,
			lang = i18next.language,
			user_lang, new_lang,
			saved_user_lang = $.jStorage.get('user_lang')
		;

		$.jStorage.set('user_lang', saved_user_lang);

		if (!user) {
			return this;
		}

		user_lang = user.get('lang');

		if (lang !== user_lang && CONFIG.ADMIN_LANGS && ~CONFIG.ADMIN_LANGS.indexOf(user_lang)) {
			new_lang = user_lang;
		}
		if (new_lang) {

			$.jStorage.set('user_lang', user_lang);
			i18next.changeLanguage(new_lang);
			window.location = window.location.pathname;
		}
	}



	if(CONFIG.IS_PRELAUNCH && !window.customOffSeason){
		$(function(){
			var count = 0,
				prelaunch_storage = APP.getJStorage('PreLaunchTrick');
			if(!prelaunch_storage) {
				$(document).on('click', '#header, #footer, .sponsor_nimg', function() {
					count++;
					if (count >= 5) {
						APP.clearSecret();
						$(document).off('click', '#header, #footer, .sponsor_nimg');
					}
				});
			}
		});
	}

}(window, Backbone, Marionette, $, _, AjaxErrorHandlerManager, PermissionManager));